import Reporting from "./Reporting.view";

export default Reporting;
